import src from "IMAGE";
export default { src, width: 400, height: 301, blurWidth: 0, blurHeight: 0};
